import { Pie } from 'react-chartjs-2';
import { getDefaultDiagramTextColor } from '../../../../shared/utils/diagramUnivers';

const MinorResultPieChart = ({
  data,
}: {
  data: { label: string; value: number; color: string }[];
}) => (
  <div style={{ width: 206, height: 206 }}>
    <Pie
      width={206}
      height={206}
      data={{
        datasets: [
          {
            data: data.map(item => item.value),
            backgroundColor: data.map(item => item.color),
            borderWidth: 0,
          },
        ],
      }}
      options={{
        responsive: false,
        maintainAspectRatio: false,
        plugins: {
          tooltip: { enabled: false },
          datalabels: {
            display: true,
            color: data.map((item, index) =>
              getDefaultDiagramTextColor(item.color, index < 2 ? 'black' : 'white')
            ),
            clip: true,
            labels: {
              title: {
                font: { weight: 'bold', size: 11.5 },
                align: 'center',
                padding: 0,
              },
            },
            formatter: value => `${value}%`,
          },
        },
        layout: { padding: 0 },
      }}
    />
  </div>
);

export default MinorResultPieChart;
